import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MyProductReservationDetail } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function MyProductReservationDetailPage() {
    const { uuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('my-product-reservation-detail-component.metatags.title'),
        description: t('my-product-reservation-detail-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProductReservationDetail.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <MyProductReservationDetail />;
}
